import React, { useEffect, useState, useRef } from 'react';
import Button from 'react-bootstrap/Button';
import Table from 'react-bootstrap/Table';
import Container from 'react-bootstrap/Container';
import Alert from 'react-bootstrap/Alert';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import { useDispatch, useSelector } from 'react-redux';
import { scrollToTop } from '../../util';
// Importa as funções do nosso slice de usuários
import {
    fetchUsers,
    updateUser,
    deleteUser,
    setCurrentPage,
    setSearchTerm,
    setSortDirection,
    clearMessages,
    restoreUser,
    createUser
} from '../../redux/reducers/userAdmin';

// Exemplo de componente de paginação
import PaginationComponent from '../../components/paginacao';
// Exemplo de componente de loading
import Loader from '../../components/loading';

const UserList = () => {
    const dispatch = useDispatch();

    // Estados vindos do Slice (usersSlice)
    const {
        items,             // lista de usuários
        totalItems,        // total de usuários
        currentPage,       // página atual
        itemsPerPage,      // usuários por página
        loading,           // indica requisição em andamento
        error,             // mensagem de erro (ou null)
        successMessage,    // mensagem de sucesso (ou null)
        searchTerm,
        sortDirection,
    } = useSelector((state) => state.userAdmin);

    // Estados locais do componente
    const [showEditModal, setShowEditModal] = useState(false);
    const [showDetalheModal, setDetallheModal] = useState(false);
    //const [showModal, setShowModal] = useState(false);
    //const [showToast, setShowToast] = useState(false);
    const [selectedUser, setSelectedUser] = useState(null);
    //  const { searchTerm, loading } = useSelector((state) => state.users);
    const [show, setShow] = useState(false);
    const containerUsuarios = useRef(null);


    const [localSearch, setLocalSearch] = useState(searchTerm);
    // Campos do formulário de edição
    const [editName, setEditName] = useState('');
    const [editEmail, setEditEmail] = useState('');
    const [editPassword, setEditPassword] = useState('');
    //Campos para adicao de usuario
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        password: '',
    });
    const handleChange = (e) => {
        setFormData((prev) => ({
            ...prev,
            [e.target.name]: e.target.value,
        }));
    };
    //1
    useEffect(() => {
        dispatch(fetchUsers({ page: currentPage, searchTerm, sortDirection }));
    }, [dispatch, currentPage, searchTerm, sortDirection]);

    // Fecha alert de erro/sucesso
    const handleCloseAlert = () => {
        dispatch(clearMessages());
    };

    // Paginação
    const handlePageChange = (newPage) => {
        dispatch(setCurrentPage(newPage));
    };

    // Ordenação (asc <-> desc)
    const handleSort = () => {
        const newDirection = sortDirection === 'asc' ? 'desc' : 'asc';
        dispatch(setSortDirection(newDirection));
    };

    // Busca
    useEffect(() => {
        const delayDebounceFn = setTimeout(() => {
            if (localSearch.length >= 3 || localSearch.length === 0) {
                dispatch(setSearchTerm(localSearch));
            }
        }, 500); // Aguarda 500ms antes de buscar

        return () => clearTimeout(delayDebounceFn); // Limpa timeout se o usuário continuar digitando
    }, [localSearch, dispatch]);

    // Abre Modal de edição e carrega dados do usuário selecionado
    const handleEdit = (user) => {
        setSelectedUser(user);
        setEditName(user.name || '');
        setEditEmail(user.email || '');
        setEditPassword('');
        setShowEditModal(true);
    };

    const handleDetahe = (user) => {
        console.log(user, 'user')
        setSelectedUser(user);
        setDetallheModal(true);
    };

    // Envia alterações do formulário
    const handleUpdateUser = () => {
        if (!selectedUser) return;

        const payload = {
            userId: selectedUser.id,
            userData: {
                name: editName,
                email: editEmail,
            }
        };

        // Se o usuário preencheu uma nova senha, incluímos no payload
        if (editPassword.trim()) {
            payload.userData.password = editPassword;
        }

        dispatch(updateUser(payload))
            .unwrap()
            .then(() => {
                setShowEditModal(false);
                scrollToTop(containerUsuarios)
            })
            .catch(() => {
                setShowEditModal(false);
                scrollToTop(containerUsuarios)
            });
    };

    // Deletar usuário
    /*const handleDelete = (userId) => {
        if (window.confirm('Tem certeza que deseja deletar este usuário?')) {
            dispatch(deleteUser(userId));
        }
    };*/

    // Lógica para calcular total de páginas
    const totalPages = Math.ceil(totalItems / itemsPerPage);

    const abrirModalCadastro = () => {
        setShow(true);
    }

    const fecharModalCadastro = () => {
        setShow(false);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        await dispatch(createUser(formData));
        setShow(false);
        scrollToTop(containerUsuarios)
    };

    return (
        <Container ref={containerUsuarios}>
            <h2 className="text-center mb-4 titulo-modal titulo-pagina"><i style={{ color: '#ff7a00' }} class="fa-solid fa-user-tie mr-3"></i> Gerenciar Usuários</h2>

            {/* Mensagens de Sucesso ou Erro */}
            {successMessage && (
                <Alert variant="success" onClose={handleCloseAlert} dismissible className="text-center">
                    {successMessage}
                </Alert>
            )}
            {error && (
                <Alert variant="danger" className="text-center" style={{ textDecoration: "none" }}>
                    <Button
                        variant="outline-danger"
                        size="sm"
                        style={{ position: "absolute", top: "5px", right: "10px" }}
                        onClick={() => dispatch(clearMessages())} // Remove o erro do Redux
                    >
                        ✖
                    </Button>

                    <ul className="mb-0">
                        {typeof error === "string" ? (
                            // Se error for uma string, exibe diretamente
                            <li>{error}</li>
                        ) : typeof error === "object" && error !== null ? (
                            // Se error for um objeto, percorre suas chaves e exibe os erros
                            Object.entries(error).map(([field, messages]) =>
                                Array.isArray(messages) ? (
                                    messages.map((msg, index) => <li key={`${field}-${index}`}>{msg}</li>)
                                ) : (
                                    <li key={field}>{String(messages)}</li> // Garante que qualquer valor é convertido em string
                                )
                            )
                        ) : (
                            // Caso erro tenha um formato inesperado
                            <li>Ocorreu um erro desconhecido.</li>
                        )}
                    </ul>
                </Alert>
            )}
            {/* Componente de paginação */}
            <div className="d-flex justify-content-center">
                <PaginationComponent
                    currentPage={currentPage}
                    lastPage={totalPages}
                    onPageChange={handlePageChange}
                />
            </div>
            <div className="mb-3 d-flex justify-content-end align-items-center">
                {/* Campo de busca e botão de ordenar */}
                <div className="position-relative" style={{ maxWidth: '300px' }}>
                    <Form.Control
                        type="text"
                        placeholder="Digite 3 ou mais caracteres"
                        value={localSearch}
                        onChange={(e) => setLocalSearch(e.target.value)}
                        style={{ paddingRight: '2rem' }}
                    />
                    {localSearch && (
                        <i
                            className="fa-solid fa-xmark"
                            style={{
                                position: 'absolute',
                                top: '50%',
                                right: '10px',
                                transform: 'translateY(-50%)',
                                cursor: 'pointer',
                                color: '#888',
                            }}
                            onClick={() => setLocalSearch('')} // Limpa a busca
                        />
                    )}
                </div>
                <div className="d-flex justify-content-end align-items-center">
                    <Button variant="secondary" onClick={handleSort} className="p-1 ms-2">
                        Ordenar
                        {sortDirection === 'asc' ? (
                            <i className="fa-solid fa-sort-up p-2"></i>
                        ) : (
                            <i className="fa-solid fa-sort-down p-2"></i>
                        )}
                    </Button>
                </div>
            </div>
            <div className="d-flex justify-content-end align-items-center">
                <Button variant="primary" onClick={abrirModalCadastro} className="p-2 ms-2">Adicionar Usuário</Button>
            </div>
            {/* Loader */}
            <div className={`loading ${loading ? 'loading-active' : ''}`}>
                <Loader loading={loading} />
                {/* Tabela de usuários */}
                <Table bordered hover responsive className="tabela-painel text-center mt-4" style={{ fontSize: '0.9em' }}>
                    <thead>
                        <tr className='cabecalho-tabela'>
                            <th>ID</th>
                            <th>Nome</th>
                            <th>Email</th>
                            <th>Ações</th>
                        </tr>
                    </thead>
                    <tbody>
                        {items && items?.length > 0 ? (
                            items?.map((user) => (
                                <tr key={user.id} className='celula-tabela'>
                                    <td>{user.id}</td>
                                    <td>{user.name}</td>
                                    <td>{user.email}</td>
                                    <td>
                                        <div className='table-actions'>
                                            <Button
                                                variant="info"
                                                size="sm"
                                                onClick={() => handleDetahe(user)}
                                                style={{ width: '100px', marginRight: '10px' }}
                                            >
                                                Ver Detalhes
                                            </Button>
                                            <Button
                                                variant="warning"
                                                size="sm"
                                                onClick={() => handleEdit(user)}
                                                style={{ width: '100px', marginRight: '10px' }}
                                            >
                                                Editar
                                            </Button>

                                            {user.deleted_at ? (
                                                <Button
                                                    variant="success"
                                                    size="sm"
                                                    onClick={() => dispatch(restoreUser(user.id))}
                                                    style={{ width: '100px' }}
                                                >
                                                    Ativar
                                                </Button>
                                            ) : (
                                                <Button
                                                    variant="danger"
                                                    size="sm"
                                                    onClick={() => dispatch(deleteUser(user.id))}
                                                    style={{ width: '100px' }}
                                                >
                                                    Desativar
                                                </Button>
                                            )}
                                        </div>
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="4">Nenhum usuário encontrado.</td>
                            </tr>
                        )}
                    </tbody>
                </Table>
            </div>
            {/* Modal de Edição */}
            <Modal show={showEditModal} onHide={() => setShowEditModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title className='w-100 text-center titulo-modal'>Editar Usuário</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group controlId="editName">
                            <Form.Label>Nome</Form.Label>
                            <Form.Control
                                type="text"
                                value={editName}
                                onChange={(e) => setEditName(e.target.value)}
                            />
                        </Form.Group>
                        <Form.Group controlId="editEmail" className="mt-3">
                            <Form.Label>Email</Form.Label>
                            <Form.Control
                                type="email"
                                value={editEmail}
                                onChange={(e) => setEditEmail(e.target.value)}
                            />
                        </Form.Group>
                        <Form.Group controlId="editPassword" className="mt-3">
                            <Form.Label>Senha (opcional)</Form.Label>
                            <Form.Control
                                type="password"
                                value={editPassword}
                                onChange={(e) => setEditPassword(e.target.value)}
                                placeholder="Deixe em branco para não alterar a senha"
                            />
                        </Form.Group>
                        {/* Campos adicionais, se necessário */}
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowEditModal(false)}>
                        Cancelar
                    </Button>
                    <Button variant="primary" onClick={handleUpdateUser}>
                        {loading ? 'Salvando...' : 'Salvar Alterações'}
                    </Button>
                </Modal.Footer>
            </Modal>
            {/* Modal de Cadastro */}
            <Modal show={show} onHide={fecharModalCadastro}>
                <Modal.Header closeButton>
                    <Modal.Title className='w-100 text-center titulo-modal'>Cadastrar Usuário</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={handleSubmit}>
                        <Form.Group className="mb-3">
                            <Form.Label>Nome</Form.Label>
                            <Form.Control type="text" name="name" value={formData.nome} onChange={handleChange} required />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Email</Form.Label>
                            <Form.Control type="email" name="email" value={formData.email} onChange={handleChange} required />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Senha</Form.Label>
                            <Form.Control type="password" name="password" value={formData.senha} onChange={handleChange} required />
                        </Form.Group>
                        <div className='d-flex justify-content-center align-items-center'>
                            <Button variant="primary" className="text-center" type="submit">Cadastrar</Button>
                        </div>
                    </Form>
                </Modal.Body>
            </Modal>
            {/*Modal de dados do usuario*/}
            <Modal className="modal-custom" show={showDetalheModal} onHide={() => setDetallheModal(false)} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title className='w-100 text-center titulo-modal'>Dados do usuário</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className='box-option'>
                        <ul>
                            {selectedUser?.name && (
                                <li><p><i className="fa-solid fa-check"></i><span className="option-value"><strong>Nome:</strong> {selectedUser.name}</span></p></li>
                            )}
                            {selectedUser?.email && (
                                <li><p><i className="fa-solid fa-check"></i><span className="option-value"><strong>E-mail:</strong> {selectedUser.email}</span></p></li>
                            )}
                            {selectedUser?.telefone && (
                                <li><p><i className="fa-solid fa-check"></i><span className="option-value"><strong>Telefone:</strong> {selectedUser.telefone}</span></p></li>
                            )}
                            {selectedUser?.data_nascimento && (
                                <li><p><i className="fa-solid fa-check"></i><span className="option-value"><strong>Data de Nascimento:</strong> {selectedUser.data_nascimento}</span></p></li>
                            )}
                            {selectedUser?.rg && (
                                <li><p><i className="fa-solid fa-check"></i><span className="option-value"><strong>RG:</strong> {selectedUser.rg}</span></p></li>
                            )}
                            {selectedUser?.cpf && (
                                <li><p><i className="fa-solid fa-check"></i><span className="option-value"><strong>CPF:</strong> {selectedUser.cpf}</span></p></li>
                            )}
                        </ul>
                    </div>

                    {selectedUser?.address && (
                        <div className='box-option'>
                            <h4 className='pb-3' style={{ fontWeight: 700 }}>Endereço</h4>
                            <ul>
                                {selectedUser.address.address && (
                                    <li><p><i className="fa-solid fa-check"></i><span className="option-value"><strong>Rua:</strong> {selectedUser.address.address}</span></p></li>
                                )}
                                {selectedUser.address.number && (
                                    <li><p><i className="fa-solid fa-check"></i><span className="option-value"><strong>N°:</strong> {selectedUser.address.number}</span></p></li>
                                )}
                                {selectedUser.address.complement && (
                                    <li><p><i className="fa-solid fa-check"></i><span className="option-value"><strong>Complemento:</strong> {selectedUser.address.complement}</span></p></li>
                                )}
                                {selectedUser.address.neighborhood && (
                                    <li><p><i className="fa-solid fa-check"></i><span className="option-value"><strong>Bairro:</strong> {selectedUser.address.neighborhood}</span></p></li>
                                )}
                                {selectedUser.address.city && (
                                    <li><p><i className="fa-solid fa-check"></i><span className="option-value"><strong>Cidade:</strong> {selectedUser.address.city}</span></p></li>
                                )}
                                {selectedUser.address.state && (
                                    <li><p><i className="fa-solid fa-check"></i><span className="option-value"><strong>Estado:</strong> {selectedUser.address.state}</span></p></li>
                                )}
                                {selectedUser.address.cep && (
                                    <li><p><i className="fa-solid fa-check"></i><span className="option-value"><strong>CEP:</strong> {selectedUser.address.cep}</span></p></li>
                                )}
                            </ul>
                        </div>
                    )}
                </Modal.Body>
            </Modal>
        </Container>
    );
};

export default UserList;
